class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.isHeaderSearch = this.matches('.header__search');
    this.headerSection = this.isHeaderSearch ? this.closest('.section-header') : null;
    this.searchScrollPosition = null;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  connectedCallback() {
    if (!this.isHeaderSearch) return;

    this.onPageShowEvent = this.onPageShowEvent || this.onPageShow.bind(this);
    window.addEventListener('pageshow', this.onPageShowEvent);
  }

  disconnectedCallback() {
    if (!this.isHeaderSearch) return;

    window.removeEventListener('pageshow', this.onPageShowEvent);
    if (this.isOpen()) this.close(false);
    else this.setHeaderSearchOpen(false);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(this.isHeaderSearch);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    if (this.isHeaderSearch) {
      this.searchScrollPosition = { x: window.scrollX, y: window.scrollY };
      this.setHeaderSearchGeometry();
      this.setHeaderSearchOpen(true);
    }

    try {
      event.target.closest('details').setAttribute('open', true);
      this.summaryToggle.setAttribute('aria-expanded', 'true');
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
      this.restoreSearchScrollPosition();

      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    } catch (error) {
      this.close(false);
      throw error;
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.setHeaderSearchOpen(false);
    this.clearHeaderSearchGeometry();
    this.restoreSearchScrollPosition();
    this.searchScrollPosition = null;
  }

  setHeaderSearchOpen(isOpen) {
    if (!this.headerSection) return;

    const hasAnotherOpenSearch =
      !isOpen && Boolean(this.headerSection.querySelector('details-modal.header__search details[open]'));
    this.headerSection.classList.toggle('signature-search-open', isOpen || hasAnotherOpenSearch);
  }

  setHeaderSearchGeometry() {
    if (!this.headerSection) return;

    const headerRect = this.headerSection.getBoundingClientRect();
    this.detailsContainer.style.setProperty('--header-search-modal-top', `${Math.max(0, headerRect.top)}px`);
    this.detailsContainer.style.setProperty('--header-search-modal-height', `${headerRect.height}px`);
  }

  clearHeaderSearchGeometry() {
    this.detailsContainer.style.removeProperty('--header-search-modal-top');
    this.detailsContainer.style.removeProperty('--header-search-modal-height');
  }

  restoreSearchScrollPosition() {
    if (!this.searchScrollPosition) return;

    const { x, y } = this.searchScrollPosition;
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo({ left: x, top: y, behavior: 'auto' });
  }

  onPageShow() {
    if (this.isOpen()) this.close(false);
    else this.setHeaderSearchOpen(false);
  }
}

customElements.define('details-modal', DetailsModal);
